/* eslint-disable no-underscore-dangle */
import {
  legacy_createStore as createStore,
  applyMiddleware,
  compose,
} from 'redux';
import { thunk } from 'redux-thunk';
import rootReducer from './reducers';

if (import.meta.hot) {
  import.meta.hot.accept(async (newModule) => {
    if (newModule) {
      const nextRootReducer = await import('./reducers');
      window.__REDUX_STORE__.replaceReducer(nextRootReducer.default);
    }
  });
}

export default () => {
  const store = createStore(
    rootReducer,
    window.__PRELOADED_STATE__ || {},
    reduxDevtoolsComposer()(applyMiddleware(thunk)),
  );
  window.__REDUX_STORE__ = store;
  return store;
};

function reduxDevtoolsComposer() {
  if (!window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) return compose;
  return window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    actionSanitizer,
    stateSanitizer,
  });
}

function actionSanitizer(action) {
  if (action.type === 'MAP_LOAD_END') return { type: action.type };
  return action;
}

function stateSanitizer(state) {
  return { ...state, map: { view: 'TOO BIG TO DISPLAY IN DEVTOOLS' } };
}
